import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum AiAnalyzedFileSource {
  UPLOAD = "upload",
  FORWARD = "forward",
}

export const aiAnalyzedFileSchema = z.object({
  _id: zExt.objectId(),
  teamId: zExt.objectId(),
  url: z.string(),
  filename: z.string(),
  mimeType: z.string(),
  source: createEnum(AiAnalyzedFileSource),
  analysis: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type AiAnalyzedFile = z.infer<typeof aiAnalyzedFileSchema>;

export interface CreateAiAnalyzedFileParams {
  teamId: string;
  url: string;
  filename: string;
  mimeType: string;
  source: AiAnalyzedFileSource;
  analysis: string;
}
